interface IProps {
  quarter: 'Q1' | 'Q2' | 'Q3' | 'Q4'
}

export const YearAndQuarterTh = ({ quarter }: IProps) => {
  return (
    <div>
      <div>{quarter}</div>
    </div>
  )
}
